import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1300px;
  padding-bottom: 40px;

  .profile-header-container {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 20px;
    margin-bottom: 25px;
    @media (max-width: 1000px) {
      grid-template-columns: 1fr;
    }
  }

  .photo-card {
    background: #fff;
    border-radius: 20px;
    padding: 25px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;

    .photo-container {
      position: relative;
      img {
        width: 140px;
        height: 140px;
        border-radius: 50%;
        object-fit: cover;
        border: 4px solid #008037;
        padding: 3px;
        background: #fff;
      }
    }

    h3 {
      margin: 0;
      font-size: 18px;
      color: #333;
    }
    p {
      margin: 0;
      color: #888;
      font-size: 13px;
      text-transform: capitalize;
    }
  }

  .info-card {
    background: #fff;
    border-radius: 20px;
    padding: 20px 25px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    position: relative;

    .card-header-actions {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 15px;
      gap: 20px;

      @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
      }
    }

    .section-title {
      font-size: 15px;
      font-weight: 600;
      color: #008037;
      display: flex;
      align-items: center;
      gap: 10px;
      flex: 1;
      &::after {
        content: "";
        flex: 1;
        height: 1px;
        background: #f0f0f0;
      }
    }

    .info-grid-profile {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 15px 20px;
      @media (max-width: 768px) {
        grid-template-columns: 1fr 1fr;
      }
      @media (max-width: 500px) {
        grid-template-columns: 1fr;
      }

      .info-item {
        display: flex;
        flex-direction: column;
        gap: 2px;
        label {
          font-size: 11px;
          color: #999;
          font-weight: 500;
          text-transform: uppercase;
        }
        span {
          font-size: 14px;
          color: #333;
          font-weight: 600;
        }
      }
    }

    .actions-profile {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;

      button {
        padding: 8px 18px;
        border-radius: 50px;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        gap: 8px;
        border: none;
        font-size: 12px;
        white-space: nowrap;
      }

      .primary-btn {
        background: #008037;
        color: white;
        &:hover {
          opacity: 0.9;
        }
      }

      .secondary-btn {
        background: #fff;
        color: #008037;
        border: 1px solid #008037;
        &:hover {
          background: #f0fdf4;
        }
      }
    }
  }

  /* Abas centralizadas e estilizadas como botões de ação */
  .ant-tabs-nav-wrap {
    display: flex;
    justify-content: center;
  }

  .ant-tabs-nav {
    margin-bottom: 25px !important;
    background: transparent !important;
    padding: 0 !important;
    border: none !important;

    &::before {
      display: none;
    }

    .ant-tabs-nav-list {
      gap: 15px;
    }
  }

  .ant-tabs-tab {
    background: #fff !important;
    border: 1px solid #008037 !important;
    border-radius: 50px !important;
    padding: 8px 25px !important;
    height: 42px !important;
    transition: all 0.3s !important;
    margin: 0 !important;

    .ant-tabs-tab-btn {
      color: #008037 !important;
      font-weight: 700 !important;
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
    }

    .count-badge {
      background: #e6f4ea;
      color: #008037;
      padding: 2px 10px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 800;
    }

    &:hover {
      background: #f0fdf4 !important;
    }

    &.ant-tabs-tab-active {
      background: #008037 !important;
      box-shadow: 0 4px 12px rgba(0, 128, 55, 0.3);

      .ant-tabs-tab-btn {
        color: #fff !important;
      }

      .count-badge {
        background: rgba(255, 255, 255, 0.2);
        color: #fff;
      }
    }
  }

  .ant-tabs-ink-bar {
    display: none !important;
  }

  .dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 20px;
  }

  .section-title-dash {
    font-size: 17px;
    font-weight: 600;
    color: #333;
    margin: 25px 0 15px 0;
    display: flex;
    align-items: center;
    gap: 10px;

    &::after {
      content: "";
      flex: 1;
      height: 1px;
      background: #f0f0f0;
    }
  }

  .main-tags {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    margin-bottom: 25px;
    width: 100%;

    @media (max-width: 1100px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 700px) {
      grid-template-columns: 1fr;
    }
  }

  .tag-item {
    padding: 20px 25px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    background: #fff;
    color: #333;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;

    .tag-header {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }

    .value {
      font-size: 22px;
      color: #1a1a1a;
      font-weight: 800;
      margin-top: 2px;
    }

    &.highlight {
      border-left: 4px solid #008037;
      .value {
        color: #008037;
      }
    }

    &.warning {
      border-left: 4px solid #f2760a;
      .value {
        color: #f2760a;
      }
    }
  }

  .status-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 12px;
    margin-bottom: 25px;
  }

  .status-tag {
    background: #fff;
    padding: 15px 22px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s;
    cursor: pointer;

    &:hover {
      border-color: var(--color);
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    }

    .label {
      color: #666;
      font-size: 15px;
      font-weight: 500;
    }

    .count {
      font-size: 18px;
      font-weight: 800;
      color: var(--color);
    }
  }

  .main-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 25px;
  }

  .insight-card {
    background: #fff;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.06);
    }

    .icon-wrapper {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;

      &.green {
        background: #e6f4ea;
        color: #008037;
      }
      &.orange {
        background: #fff4e6;
        color: #f2760a;
      }
      &.blue {
        background: #e6f7ff;
        color: #1890ff;
      }
    }

    label {
      font-size: 12px;
      color: #888;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .value-row {
      display: flex;
      align-items: baseline;
      gap: 10px;
      margin-top: 5px;

      h3 {
        font-size: 24px;
        font-weight: 800;
        margin: 0;
        color: #1a1a1a;
      }

      span.unit {
        font-size: 13px;
        color: #999;
        font-weight: 600;
      }
    }

    .footer-info {
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #f9f9f9;
      font-size: 11px;
      color: #666;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }

  .conversion-insight {
    grid-column: span 1;
    background: linear-gradient(135deg, #ffffff 0%, #f8faf9 100%);

    .progress-container {
      margin-top: 15px;
      .ant-progress-inner {
        background-color: #f0f0f0;
      }
    }
  }

  .filters {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    align-items: flex-end;
    margin-bottom: 30px;
    background: #f9f9f9;
    padding: 20px;
    border-radius: 15px;
    border: 1px solid #eee;
  }

  /* Novo Estilo de Listagem */
  .leads-list,
  .payments-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .lead-card,
  .payment-card {
    background: #fff;
    padding: 15px 25px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    display: grid;
    align-items: center;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);

    &:hover {
      border-color: #008037;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateX(5px);
    }

    @media (max-width: 1000px) {
      grid-template-columns: 1fr 1fr !important;
      gap: 15px;
      padding: 20px;
    }

    .main-info {
      display: flex;
      flex-direction: column;
      strong {
        font-size: 15px;
        color: #333;
      }
      span {
        font-size: 12px;
        color: #999;
      }
    }

    .contact-info {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: #666;
      svg {
        color: #008037;
      }
    }

    .date-info {
      font-size: 13px;
      color: #888;
      display: flex;
      flex-direction: column;
      label {
        font-size: 10px;
        text-transform: uppercase;
        color: #bbb;
      }
    }

    .actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    }
  }

  .lead-card {
    grid-template-columns: 2fr 1.5fr 1.5fr 1.2fr 1fr 80px;
  }

  .payment-card {
    grid-template-columns: 2fr 1fr 1fr 1fr;
  }

  .value-info {
    padding: 5px 12px;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-right: 25px;
    width: 160px;

    &.pendente {
      color: #8c8c8c;
    }
    &.fechado {
      color: #52c41a;
    }
    &.perdido {
      color: #f5222d;
    }
    &.default {
      color: #faad14;
    }
    strong {
      font-size: 15px;
    }
    span {
      font-size: 12px;
    }

    @media (max-width: 1000px) {
      width: 100%;
      text-align: left;
      margin-right: 0;
    }
  }

  .status-badge-payment {
    padding: 5px 12px;
    border-radius: 50px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    width: fit-content;
    background: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
  }

  .status-badge {
    padding: 5px 12px;
    border-radius: 50px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    width: fit-content;

    &.pendente {
      background: #fff1f0;
      color: #f5222d;
      border: 1px solid #ffa39e;
    }
    &.oportunidade {
      background: #e6f7ff;
      color: #1890ff;
      border: 1px solid #91d5ff;
    }
    &.atendimento {
      background: #f9f0ff;
      color: #722ed1;
      border: 1px solid #d3adf7;
    }
    &.fechado {
      background: #f6ffed;
      color: #52c41a;
      border: 1px solid #b7eb8f;
    }
    &.perdido {
      background: #f5f5f5;
      color: #8c8c8c;
      border: 1px solid #d9d9d9;
    }
    &.default {
      background: #fffbe6;
      color: #faad14;
      border: 1px solid #ffe58f;
    }
  }

  .payment-value {
    font-size: 16px;
    font-weight: bold;
    color: #008037;
  }
`;

export const AssociateInfo = styled.div`
  background: #f8faf9;
  border: 1px solid #d7f0db;
  border-radius: 10px;
  padding: 15px;
  margin-top: 20px;
  display: flex;
  gap: 15px;
  align-items: center;

  img {
    width: 60px !important;
    height: 60px !important;
    border-radius: 8px !important;
    object-fit: cover;
    margin: 0 !important;
  }

  .info {
    display: flex;
    flex-direction: column;

    strong {
      font-size: 14px;
      color: #333;
    }
    span {
      font-size: 12px;
      color: #666;
    }
  }
`;

export const InfoTag = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 15px 0;

  .tag {
    background: #f0f0f0;
    padding: 4px 12px;
    border-radius: 50px;
    font-size: 11px;
    color: #555;
    border: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
`;

export const Label = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
  background: ${(props) => props.color};
`;
